// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { GlobalValidator } from "../types";

import { createValidator } from "#stdnum-runtime";

const lei: GlobalValidator = createValidator("lei", 113);

export default lei;
export const compact = lei.compact;
export const format = lei.format;
export const validate = lei.validate;
export const generate = (): string =>
  lei.generate?.() ??
  (() => {
    throw new Error("Validator lei cannot generate values");
  })();
